import { defineMessages } from 'react-intl';

const joinMessages = defineMessages({
  header: {
    id: 'join.header',
    defaultMessage: 'Join {organizationName} on AWS Skill Builder',
    description:
      'Main heading on the shareable invite link page. {organizationName} is the name of the organization the learner is joining.',
  },
  subtitle: {
    id: 'join.subtitle',
    defaultMessage:
      "You've been invited to join {organizationName}'s AWS Skill Builder organization. Enter your work email address to continue.",
    description:
      'Explanation under the heading on the shareable invite link page. {organizationName} is the name of the organization the learner is joining.',
  },
  emailLabel: {
    id: 'join.emailLabel',
    defaultMessage: 'Work email address',
    description: 'Label for the email input on the shareable invite link page.',
  },
  emailHelper: {
    id: 'join.emailHelper',
    defaultMessage:
      "Enter the email address associated with your organization's account.",
    description: 'Helper text shown above the email input.',
  },
  emailPlaceholder: {
    id: 'join.emailPlaceholder',
    defaultMessage: 'alex.johnson@acme.com',
    description:
      'Example work email address shown as placeholder text in the email input.',
  },
  emailFootnote: {
    id: 'join.emailFootnote',
    defaultMessage: 'Use your organization email address, not a personal one.',
    description: 'Helper text shown below the email input.',
  },
  linkNotActive: {
    id: 'join.linkNotActive',
    defaultMessage: 'This invite link is not active',
    description:
      'Heading shown when a shareable invite link is expired, deleted, or invalid.',
  },
  linkNotActiveBody: {
    id: 'join.linkNotActiveBody',
    defaultMessage:
      "The invite link you used has been disabled by your organization's admin. Contact your Learning Admin to request access or ask them to re-enable the link.",
    description:
      'Explanation under the heading when a shareable invite link is not active.',
  },
});

export default joinMessages;
